export default function <T extends object>(a: T, b: T, dataKey: keyof T) {
  if (a[dataKey] < b[dataKey]) {
    return -1;
  }
  if (a[dataKey] > b[dataKey]) {
    return 1;
  }
  return 0;
}
